import { Button, theme } from '@bpba/ui-components';
import { useNavigate } from 'react-router-dom';
import { UrlsFront } from '../constants/urls';
import { FC } from 'react';
import { FixedTermStatus, IFixedTermItem } from '../types/IFixedTermItem';
import styled from 'styled-components';

type Props = {
  data: IFixedTermItem;
};

export const AceptationButton: FC<Props> = ({ data }) => {
  const navigate = useNavigate();

  if (data?.status !== FixedTermStatus.DEBIN_SIN_AUTORIZAR && data?.status !== FixedTermStatus.ERROR_PLAZOFIJO) return <></>;

  const onClick = () => {
    navigate(UrlsFront.DebinConfirm, { state: data });
  };

  return (
    <StyledButton
      type="button"
      mx={'0px !important'}
      fontSize={'12px'}
      lineHeight={'normal'}
      border={'4px solid !important'}
      borderColor={`${theme.colors.tertiary[0]} !important`}
      backgroundColor={`${theme.colors.tertiary[0]} !important`}
      color={'white !important'}
      onClick={onClick}
      width={'100%'}
      mt={['0px!important', '24px !important']}
    >
      Ya acepté el DEBIN en mi banco
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  white-space: nowrap;
`;
